import {TFunction} from 'i18next';
import React from 'react';
import {withTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {clearError} from '../../../../features/layout/layoutSlice';
import {RootState} from '../../../store';
import CompoundMessage from './CompoundMessage';

export type ApiError = {
  exceptionMessage?: string,
  stackTrace?: string,
  exceptionType?: string,
  innerException?: ApiError,
  message: string,
  referanseId: string,
}

type State = ({
  hasError: true,
  error: string | Error
} | {
  hasError: false,
});

let lastErr: string | Error | null = null;
const mapStateToProps = (state: RootState) => {
  const error = state.layout.error;
  let hasError = false;

  if (typeof error !== 'undefined') {
    lastErr = error;
    hasError = true;
  } else {
    lastErr = null;
  }
  return {
    hasError,
    error: lastErr,
  };
};

export const ErrorBoundary = connect(mapStateToProps, {clearError})(withTranslation()(class extends React.Component<{
  error: string | Error | null,
  hasError: boolean,
  clearError: () => void,
  t: TFunction,
  children: JSX.Element,
}, State> {
  state: State = {
    hasError: false,
  };

  onClose() {
    this.props.clearError();
    this.setState({
      hasError: false,
    });
  }


  static getDerivedStateFromError(error: Error | string) {
    return {
      hasError: true,
      error
    };
  }
  render() {
    let error = this.props.error; // Handled redux error
    let hasError = this.props.hasError;
    return (<>
      {
        hasError &&
        (
          <CompoundMessage error={error!} open={hasError} onClose={() => this.onClose()}/>
        )
      }
     {this.props.children}
    </>);
  }
}));

